import EntityType from '@enums/EntityType';
import resolveActivityProcess from '@utils/entityMaps/resolveActivityProcess';
import isProcess from '@utils/processes/isProcess';

export default function isSameTreePath({ a, b, order, library }) {
  for (const item of order) {
    if (isProcess(item.type)) {
      const processA = resolveActivityProcess(a[EntityType.ACTIVITY], library);
      const processB = resolveActivityProcess(b[EntityType.ACTIVITY], library);

      if (processA.l1?.uuid !== processB.l1?.uuid) {
        return false;
      }
      if (processA.l2?.uuid !== processB.l2?.uuid) {
        return false;
      }
      continue;
    }

    const entityA = a[item.type];
    const entityB = b[item.type];

    if (!entityA && !entityB) {
      continue;
    }

    if (entityA?.uuid !== entityB?.uuid) {
      return false;
    }

    if (item.subType === EntityType.ACTIVITY_TYPE) {
      if (entityA?.library_uuid !== entityB?.library_uuid) {
        return false;
      }
    }

    if (item.subType === EntityType.ROLE_TYPE) {
      if (entityA?.title !== entityB?.title) {
        return false;
      }
    }
  }

  return true;
}
